import {Component, OnInit} from '@angular/core';
import {Customer} from 'src/app/raintree/interface/customer-profile/customer';
import {GlobalService} from 'src/app/services/global.service';
import {GetAndSetCartDataInLocalstorageService} from "../../cart/service/set-cart-data-in-localstorage.service";
import {RequestMapperService} from "../../request-mapper.service";
import {GetCart} from "../../cart/interface/cart-get";
import {CartTransmissionService} from "../../raintree/transmission/cart/cart-transmission.service";
import {AddOrderTransmissionService} from "../../raintree/transmission/order-transmission/order-transmission.service";
import {OrderList} from "../interface/order-list";
import {MatDialog} from "@angular/material/dialog";
import {OrderCancellationDialogComponent} from "../order-cancellation-dialog/order-cancellation-dialog.component";
import {OrderListBpm} from "../interface/order-list-bpm";

@Component({
	selector: 'fb-profile-dashboard',
	templateUrl: './profile-dashboard.component.html',
	styleUrls: ['./profile-dashboard.component.scss']
})
export class ProfileDashboardComponent implements OnInit {
	public name: string = '';
	public cartList: GetCart[] = [];
	public filteredOrderList: OrderListBpm[] = [];
	public orderListBpm: OrderListBpm[] = [];
	public fontAwesomeLink: string = '';
	public today: number = new Date().getTime();
	public msIn24Hours = 24 * 60 * 60 * 1000;

	constructor(
		public globalService: GlobalService,
		private _getCartDataInLocal: GetAndSetCartDataInLocalstorageService,
		private _cartTransmission: CartTransmissionService,
		private _orderTransmission: AddOrderTransmissionService,
		private _dialog: MatDialog
	) {

	}

	public ngOnInit(): void {
		// debugger
		this.globalService.customerProfile.subscribe((res: Customer): void => {

			this.name = res.tenant.name
		})
		if (!this.name && this.globalService.customerProfileData.tenant) {

			this.name = this.globalService.customerProfileData.tenant.name;
		}

		this.getOrderList();

		this.getCartList();

	}

	public openCart(): void {
		this._getCartDataInLocal.openCartModal.next(true)
	}

	public getCartList(): void {
		this._cartTransmission.getCartItem(
			RequestMapperService.GET_CART_ITEM,
			() => {
			},
			() => {
			},
			(response: GetCart[]) => {

				if (response.length > 0) {

					this.cartList = response;
					// console.log(this.cartList);
					this._getCartDataInLocal.cartResponse.next(response);
				}
			},
			() => {
			},
			() => {
			}
		)
	}

	public getOrderList() {
		this._orderTransmission.getOrderListBpm(
			'?pageNumber=0&pageSize=1',
			() => {
			},
			() => {
			},
			(response: OrderListBpm[]) => {
				this.orderListBpm = response;
				this.orderListBpm = this.orderListBpm
					.filter(
						(order: OrderListBpm) => !['FAILED', 'INITIATED'].includes(order.status)
					).sort((a: OrderListBpm, b: OrderListBpm) => b.createdAt - a.createdAt);

				this.filteredOrderList = [
					...this.orderListBpm.filter(order => ['PROCESSING', 'IN_TRANSIT'].includes(order.status)),
					...this.orderListBpm.filter(order => order.status === 'DISPATCHED'),
					...this.orderListBpm.filter(order => order.status === 'CANCELLED')
				];
			},
			() => {
			},
			() => {
			}
		)
	}

	public cancelOrder(orderId: number): void {
		this._dialog.open(OrderCancellationDialogComponent, {
			data: { orderId: orderId },
			maxWidth: '80vw',
			maxHeight: '90vh'
		});
	}

	public getProductLink(cart: GetCart): string {
		if(cart.finishedProductPreview) {
			return '/product/finished-product/' + cart.finishedProductPreview.product.slug;
		}
		else  {
			return '/product/fabric-product/' + cart.fabricProductPreview?.product.slug;
		}
	}
}
